
import { Vue, Component } from 'vue-property-decorator';
import BaseDialog from '@/modules/shared/components/dialogs/BaseDialog.vue';
import { APP_NAME } from '@/plugins/config';

@Component({
    components: { BaseDialog },
})
export default class MissingLicenseDlg extends Vue {
    private readonly APP_NAME: string = APP_NAME;
    private readonly contactEmail: string = process.env.VUE_APP_SUPPORT_EMAIL ?? '';
    private readonly contactPhoneNumber: string = process.env.VUE_APP_SUPPORT_PHONE ?? '';

    private close() {
        this.$emit('close');
    }
}
